module.exports = __webpack_public_path__ + "img/Avatar-The-Last-Airbender-256.4fff97a1.png";